'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import NavigationTracker from '@/components/utilities/navigation-tracker/navigation-tracker';
import { MotionProvider } from '@/libraries/contexts/motion-provider/motion-provider';
import { createClientTelemetry } from '@/libraries/monitoring/telemetry-client';
import { reportWebVitals } from '@/libraries/monitoring/web-vitals';

const queryClient = new QueryClient();

const Providers = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    createClientTelemetry();
  }, []);

  useReportWebVitals(reportWebVitals);

  return (
    <QueryClientProvider client={queryClient}>
      <MotionProvider>
        <NavigationTracker />

        {children}
      </MotionProvider>
    </QueryClientProvider>
  );
};

Providers.displayName = 'Providers';

export default Providers;
